import { StateNode, TLStateNodeConstructor } from "@tldraw/tldraw";
import { Idle } from "./toolStates/Idle";
import { Drawing } from "./toolStates/Drawing";

/** @public */
export class DrawShapeTool extends StateNode {
  static id = "customDraw";
  static initial = "idle";
  static isLockable = false;
  static useCoalescedEvents = true;
  static children(): TLStateNodeConstructor[] {
    return [Idle, Drawing];
  }

  shapeType = "customDraw";

  onExit() {
    const drawingState = this.children!["drawing"] as any;
    drawingState.initialShape = undefined;
  }
}
